export const contentBlockContainerStyle = {
    padding: '0px',
    paddingLeft: '6%',
    paddingRight: '6%',
    paddingTop: '35px',
    paddingBottom: '35px',
};
